import React from 'react';
import { Paper, PaperProps } from '@mui/material';
import { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';

export default function AdminItemContainer({
  children,
  sx,
  ...other
}: PaperProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Paper
      square
      elevation={4}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        px: sp.s80,
        py: sp.s60,
        ...sx,
      }}
      {...other}
    >
      {children}
    </Paper>
  );
}
